import React from "react";
import { Button, Alert } from "react-bootstrap";
import { Shield } from "react-feather";
import startQuizWallpaper from "../../../../../assets/images/course/start-quiz.svg";

const ReadyForCodingAssignment = ({
  startHandler,
  language,
  testCasesCount,
  timerMinutes,
  isProctored = false,
  contentType = "code",
  title = "Ready For Coding Assignment",
  description = "Solve the problem, run your code against test cases, and submit your best solution!",
  buttonText = "Start Coding Session",
}) => {
  const isSQL = contentType === "sql";

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div>
        <img src={startQuizWallpaper} alt="coding assignment" />
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center mt-3">
        <h2>{title}</h2>
        <p className="text-center">{description}</p>

        <div className="d-flex flex-row justify-content-center gap-4 w-100 px-4 mb-2">
          {language && (
            <p className="mb-0">
              Language: <span style={{ fontWeight: "bold" }}>{language}</span>
            </p>
          )}
          {testCasesCount > 0 && (
            <p className="mb-0">
              Test Cases: <span style={{ fontWeight: "bold" }}>{testCasesCount}</span>
            </p>
          )}
          {timerMinutes && (
            <p className="mb-0">
              Time Limit: <span style={{ fontWeight: "bold" }}>{timerMinutes} min</span>
            </p>
          )}
        </div>

        {isProctored && (
          <Alert variant="warning" className="mt-2" style={{ maxWidth: "560px" }}>
            <div className="d-flex align-items-start">
              <Shield size={20} className="me-2 flex-shrink-0 mt-1" />
              <div>
                <strong>This is a Proctored {isSQL ? "SQL" : "Coding"} Assignment</strong>
                <ul className="mb-0 mt-1 ps-3 small">
                  <li>The session will open in fullscreen mode — do not exit it.</li>
                  <li>Do not switch tabs or windows while attempting the assignment.</li>
                  <li>Paste events are logged and tracked.</li>
                  <li>Developer tools and related shortcuts are blocked.</li>
                  <li>Idle time exceeding 2 minutes is flagged.</li>
                  <li>Code snapshots are taken every 3 minutes.</li>
                </ul>
              </div>
            </div>
          </Alert>
        )}

        <Button
          onClick={startHandler}
          className="px-5 py-2 fw-bold shadow-sm mt-2"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default ReadyForCodingAssignment;
